'use strict';

//Fetch module (defined in app.js)
angular.module('App.v1.Services')
	//******************** SERVICES *****************************************************************
	.factory('App.v1.Services.Account', ['$resource', '$filter',
		function ($resource, $filter) {
			return $resource(
				'/api/account/:accountId',
				{},
				{
					'action': { method: 'POST', url: '/api/account/action', isArray: false },
					'beaconStatus': { method: 'GET', url: '/api/account/beacon', isArray: false }
				}
			);
		}])
	//******************** ACCOUNT MANAGEMENT SERVICE ***********************************************
	.factory('App.v1.Services.AccountService', ['$resource', '$window', '$rootScope',
		function ($resource, $window, $rootScope) {
			var AccountResource = $resource('/api/accounts/:action/:id', {}, {
				mine: {
					method: 'GET',
					params: { action: 'mine' },
					isArray: true
				},
				default: {
					method: 'GET',
					params: { action: 'default' }
				},
				setDefault: {
					method: 'POST',
					params: { action: 'set-default' }
				}
			});

			var service = {
				getMyAccounts: getMyAccounts,
				getDefaultAccount: getDefaultAccount,
				setDefaultAccount: setDefaultAccount,
				getCurrentAccountId: getCurrentAccountId,
				switchToAccount: switchToAccount,
				initializeAccountContext: initializeAccountContext,
				accounts: [],
				currentAccount: null
			};

			// Auto-initialize account context on service load
			if ($window.IsSignedIn) {
				initializeAccountContext();
			}

			return service;

			function getMyAccounts() {
				return AccountResource.mine().$promise;
			}

			function getDefaultAccount() {
				return AccountResource.default().$promise;
			}

			function setDefaultAccount(accountId) {
				return AccountResource.setDefault({ id: accountId }).$promise;
			}

			function getCurrentAccountId() {
				return $window.sessionStorage.getItem('accountId');
			}

			function switchToAccount(account) {
				// Store new accountId
				$window.sessionStorage.setItem('accountId', account.accountId);
				$window.sessionStorage.setItem('accountName', account.organizationName);
				$window.sessionStorage.setItem('accountRole', account.role);
				$window.sessionStorage.setItem('accountKey', account.orgKey);

				service.currentAccount = account;

				// Extract current controller/action from URL
				var currentPath = $window.location.pathname;
				var match = currentPath.match(/^\/account\/([^/]+)\/?(.*)$/i);

				if (match && match[1] && match[1] !== account.orgKey) {
					if (match[2]) {
						// Preserve the current route but change account
						$window.location.href = '/account/' + account.orgKey + '/' + match[2];
					} else {
						// Go to dashboard for the new account
						$window.location.href = '/account/' + account.orgKey;
					}
					return; // Navigating away — no broadcast needed
				}

				$rootScope.$broadcast('accountService:updated', { accounts: service.accounts, currentAccount: account });
			}

			function initializeAccountContext() {
				var urlMatch = $window.location.pathname.match(/^\/account\/([^/]+)\/?(.*)$/i);

				// Always load accounts first so the service state is always populated
				getMyAccounts()
					.then(function(accounts) {
						service.accounts = accounts;

						if (urlMatch && urlMatch[1]) {
							var orgKey = urlMatch[1];
							var storedKey = $window.sessionStorage.getItem('accountKey');

							if (orgKey !== storedKey) {
								var matchedAccount = accounts.find(function(a) { return a.orgKey === orgKey; });
								if (matchedAccount) {
									switchToAccount(matchedAccount); // broadcasts accountService:updated
								} else {
									console.warn('No matching account for orgKey:', orgKey);
									$rootScope.$broadcast('accountService:updated', { accounts: accounts, currentAccount: service.currentAccount });
								}
							} else {
								// OrgKey already matches — restore current account from list
								service.currentAccount = accounts.find(function(a) { return a.orgKey === storedKey; }) || null;
								$rootScope.$broadcast('accountService:updated', { accounts: accounts, currentAccount: service.currentAccount });
							}
						} else {
							// No account in URL — fetch user's default account
							getDefaultAccount()
								.then(function(account) {
									switchToAccount(account); // broadcasts accountService:updated
								})
								.catch(function(error) {
									if (error.status === 404) {
										var path = $window.location.pathname;
										if (path !== '/account/setup' && path.toLowerCase().indexOf('/identity') === -1) {
											$window.location.href = '/account/setup';
										}
									} else {
										console.error('Account context error:', error);
									}
								});
						}
					});
			}
		}]);